import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';
import { LocalizedDatePipe } from '../../../app/shared/localizedDatePipe';
import { AttachedFileDto } from 'src/api';
import { TranslateModule } from '@ngx-translate/core';
import { TruncateNamePipe } from 'src/app/shared/truncateNamePipe';
import { Observable } from 'rxjs';

@Component({
  standalone: true,
  selector: 'app-attached-files-details',
  templateUrl: './attached-files-details.component.html',
  styleUrls: ['./attached-files-details.component.scss'],
  imports: [CommonModule, MatIconModule, RouterModule, LocalizedDatePipe, TranslateModule, TruncateNamePipe],
})
export class AttachedFilesDetailsComponent {
  @Input({ required: true }) attachedFiles$!: Observable<AttachedFileDto[]>;
  @Input({ required: true }) isPreviouslyAttachedFile!: boolean;

  downloadFile(content: string, fileName: string) {
    const byteCharacters = atob(content);
    const byteNumbers = new Array(byteCharacters.length);

    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: 'application/octet-stream' });

    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
  }
}
